import React from 'react';

export const Logo = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0H26V4.33333H0V0Z" fill="#FFE552" />
      <path
        d="M0 8.66667H13V13H4.33333C1.9401 13 0 11.0599 0 8.66667Z"
        fill="#FFE552"
      />
      <path
        d="M13 13H21.6667C24.0599 13 26 14.9401 26 17.3333H13V13Z"
        fill="#FFE552"
      />
      <path d="M0 21.6667H26V26H0V21.6667Z" fill="#FFE552" />
    </svg>
  </div>
);

Logo.displayName = 'Logo';

export default Logo;
